import { createContext, useEffect, useState } from "react";
import { food_list } from "../assets/assets";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export const StoreContext = createContext(null)

const StoreContextProvider = (props) => {

    const backendUrl = process.env.REACT_APP_FOOD_BACKEND_URL;
    const [storeid, setStoreId] = useState('SZG104000');
    const [loginState, setLoginState] = useState('');
    const [cartItems, setCartItems] = useState(() => {
        // Retrieve cart from localStorage when the component mounts
        const storedCart = localStorage.getItem("cartItems");
        return storedCart ? JSON.parse(storedCart) : {};
    });
    const [products, setProducts] = useState([]);
    const [token, setToken] = useState(localStorage.getItem('token'));
    const [totalAmount,setTotalAmount] = useState(0);
    const [orderNumber,setOrderNumber] = useState('');

  const navigate = useNavigate();


    //createToken Api Call 

    const generateToken = async () => {


        try {
            const response = await axios.post(backendUrl + '/createToken', { storeid });

            if (response.status === 200) {
                const newToken = await response.data.data;
                setToken(newToken);

                localStorage.setItem('token', newToken);
            }


        } catch (error) {
            console.log("Error:", error.response?.data || error.message);
        }

    };


    //GetMenu Api Call 

    const getMenuData = async () => {
        try {
            const response = await axios.post(backendUrl + '/getMenu', {storeID: storeid}, { headers: { Authorization: "Bearer " + token } })
            if (response.data.code === 0) {
                setProducts(response.data.data)
            }
        } catch (error) {
            console.log("Error:", error.response?.data || error.message);
        }
    }
    useEffect(() => {
        if (token) {
            setLoginState("Login")
        } else {
            generateToken(); //Called Generate Token Function

        }
    }, [storeid]);

    useEffect(() => {

        if (token) { //Check For Token Avaibility
            getMenuData();

        }

    }, [token])

    useEffect(() => {
        localStorage.setItem("cartItems", JSON.stringify(cartItems));
    }, [cartItems]);

    const addToCart = (itemId) => {
        setCartItems((prev) => ({
            ...prev,
            [itemId]: (prev[itemId] || 0) + 1,
        }));
    };




    const removeFromCart = (itemId) => {
        setCartItems((prev) => {
            const updatedCart = { ...prev };
            if (updatedCart[itemId] > 1) {
                updatedCart[itemId] -= 1;
            } else {
                delete updatedCart[itemId]; // Remove item if quantity is 0
            }
            return updatedCart;
        });
    };



    const getTotalCartAmount = () => {
        let totalAmount = 0;

        // Loop through the items in the cart
        for (const item in cartItems) {
            if (cartItems[item] > 0) {
                // Search for the item across all categories
                let itemInfo = null;
                for (const category of products) {
                    itemInfo = category.items.find((product) => product._id === item);
                    if (itemInfo) break; // Stop searching once the item is found
                }

                // If itemInfo is found, calculate the total for this item
                if (itemInfo) {
                    totalAmount += itemInfo.price * cartItems[item];
                }
            }
        }

        return totalAmount;
    };


    const checkOut = async () => {
        const cartData = Object.keys(cartItems)
            .filter((itemId) => cartItems[itemId] > 0) // Only include items with qty > 0
            .map((itemId) => ({
                productid: itemId,
                qty: cartItems[itemId],
            }));

            console.log(cartData);

        try {
            const response = await axios.post(backendUrl + '/checkOut', { cart: cartData }, { headers: { Authorization: "Bearer " + token } });
             const amountTotal = await response.data.data.total;
             const numberOrder = await response.data.data.orderNo;
            setTotalAmount(amountTotal);
            setOrderNumber(numberOrder);
        } catch (error) {
            console.error("Error sending cart data:", error);
        }
         navigate('/order')
    };





    useEffect(() => {
        // console.log(cartItems)
    }, [cartItems])

    const contextValue = {
        food_list, cartItems, setCartItems,
        addToCart, removeFromCart,
        getTotalCartAmount, backendUrl,
        token, setToken, generateToken,
        getMenuData,
        products, setProducts, 
        loginState, setLoginState, 
        checkOut,totalAmount,setTotalAmount,orderNumber,setOrderNumber,


    }
    return (
        <StoreContext.Provider value={contextValue}>
            {props.children}
        </StoreContext.Provider>
    )
}

export default StoreContextProvider